export const VerifyAction = {
  REGISTER: 'register',
  LOGIN: 'login',
  LOGIN_REFERRAL: 'preRegister',
  RESET_PW: 'resetPassword',
  RESET_GOOGLE: 'resetGoogle',
  UPDATE_PW: 'modifyPassword',
  BIND_SMS: 'bindMobile',
  BIND_EMAIL: 'bindEmail',
  BIND_GOOGLE: 'bindGoogle',
  UPDATE_SMS: 'modifyMobile',
  UPDATE_EMAIL: 'modifyEmail',
  UPDATE_GOOGLE: 'modifyGoogle',
  CLOSE_GOOGLE: 'unbindGoogle',
  OPEN_EMAIL: 'openEmail',
  CLOSE_EMAIL: 'unbindEmail',
  OPEN_MOBILE: 'openMobile',
  CLOSE_MOBILE: 'unbindMobile',
  DISABLE_ACCOUNT: 'disableAccount',
  ENABLE_ACCOUNT: 'undisableAccount',
  DELETE_ACCOUNT: 'deleteAccount',
  SET_PW: 'pwdSet',
  BIO_SET: 'biometricsOn',
  BIO_OFF: 'biometricsOff',

  PAYMENT: 'payCashier',

  TRANSFER_INTERNAL: 'transferInsite',
  WITHDRAW_APPLY: 'withdrawApply',
  WITHDRAW_ADDRESS_ADD: 'addWithdrawAddress',

  DELETE_CARD: 'cardDelete',

  ORDER_CARD: 'buyCardApplication',
  // PIN_CODE_SET: 'pinCodeFirstSet',
  PIN_CODE_UPDATE: 'pinCodeModify',
  PIN_CODE_SET: 'pinCodeSet',
  CARD_FREEZE: 'cardFreeze',
  CARD_UNFREEZE: 'cardUnFreeze',
  CARD_BACK_INFO: 'cardCheck',
}

export const VerifyOption = {
  EMAIL: 'email',
  MOBILE: 'mobile',
  GA: 'ga',
  BIO: 'bio',
  LIVE: 'live',
  PIN: 'pin',
}

export const VerifyConstant = {
  fullVerifyActions: [
    VerifyAction.UPDATE_SMS, 
    VerifyAction.UPDATE_EMAIL, 
    VerifyAction.UPDATE_GOOGLE, 
    VerifyAction.CLOSE_GOOGLE, 
    VerifyAction.CLOSE_EMAIL, 
    VerifyAction.CLOSE_MOBILE, 
    VerifyAction.WITHDRAW_APPLY, 
    VerifyAction.WITHDRAW_ADDRESS_ADD, 
    VerifyAction.DELETE_ACCOUNT,
  ],

  securityOptions: [
    VerifyAction.UPDATE_SMS, 
    VerifyAction.UPDATE_EMAIL, 
    VerifyAction.UPDATE_GOOGLE,
    VerifyAction.CLOSE_GOOGLE, 
    VerifyAction.CLOSE_EMAIL, 
    VerifyAction.CLOSE_MOBILE,
    VerifyAction.BIND_SMS, 
    VerifyAction.BIND_EMAIL, 
    VerifyAction.BIND_GOOGLE,
  ],

  securityUnauthedOptions: [
    VerifyAction.LOGIN, 
    VerifyAction.LOGIN_REFERRAL, 
    VerifyAction.RESET_PW,
  ],
}

export function security2FANeedVerifyAll(action) {
  return VerifyConstant.fullVerifyActions.indexOf(action) != -1;
}

export function security2FAIsSecurityOption(action) {
  return VerifyConstant.securityOptions.indexOf(action) != -1;
}
